import { useTranslation } from 'react-i18next';

function ContactCTA() {
  const { t } = useTranslation();

  return (
    <div className="container" id="contact">
      <div className="cta-band fade-in">
        <div>
          <div className="cta-heading">
            {t('contact.headingLine1')} <span className="acc">{t('contact.headingAccent')}</span>?<br />
            {t('contact.headingLine2')}
          </div>
          <p className="cta-sub">
            {t('contact.sub')}
          </p>
        </div>
        <div className="cta-actions">
          <a href="mailto:mikolaj.bonowski@gmail.com" className="btn btn-primary">
            {t('contact.emailUs')}
          </a>
          <a
            href="https://www.linkedin.com/in/miko%C5%82aj-b-59732676/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            {t('contact.linkedIn')}
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactCTA;
